// @ts-check
import { ref } from 'vue'

/**
 * 열기/닫기 상태를 관리하는 Composable
 * @param {boolean} [initialOpen=false] - 초기 상태
 * @returns {{
 *   open: import('vue').Ref<boolean>,
 *   onOpen: () => void,
 *   onClose: () => void,
 *   onToggle: () => void
 * }}
 */
export function useDisclosure(initialOpen = false) {
  const open = ref(initialOpen)
  const onOpen = () => (open.value = true)
  const onClose = () => (open.value = false)
  const onToggle = () => (open.value = !open.value)
  return { open, onOpen, onClose, onToggle }
}













